import { Box, CircularProgress } from "@mui/material";

export const LoadingPage = () => (
  <Box className="flex h-screen w-screen justify-center items-center">
    <CircularProgress />
  </Box>
);
